<template>
  <div class="container">
    <loader-overlay v-if="apiRslt.fetch.inProgress"/>

    <!-- Outer Row -->
    <div class="row justify-content-center">

      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">                    
                    <h1 class="h4 text-gray-900 mb-4" v-if="isResetAsked">Demande de réinitialisation </h1>
                    <h1 class="h4 text-gray-900 mb-4" v-else>Welcome Back!</h1>
                  </div>
                  <form class="user my-5" v-if="isResetAsked">
                    <div class="form-group">
                      <input
                          v-model="$v.resetForm.email.$model"
                          name="email"
                          :class="{'is-invalid': $v.resetForm.email.$error}"
                          type="text"
                          class="form-control form-control-user"
                          placeholder="Saisissez votre email"
                      >
                    </div>
                    <div class="text-center my-3 text-success" v-if="apiRslt.fetch.success">
                      <small>Un email de réinitalisation a été envoyé à l'adresse mail renseignée.</small>
                    </div>
                    <div class="text-center my-3 text-danger" v-if="apiRslt.fetch.error">
                      <small>Veuillez vérifier le mail renseigné.</small>
                    </div>
                    
                    <a v-if="!apiRslt.fetch.success" id="submit-reset" @click="submitResetAsk()" class="btn btn-primary btn-user btn-block">
                      Réinitialiser
                    </a>
                    <a v-else id="submit-reset" @click="isResetAsked = false; resetApiFetch()" class="btn btn-primary btn-user btn-block">
                      Se connecter
                    </a>
                    <a v-if="!apiRslt.fetch.success" id="cancel-reset" @click="isResetAsked = false" class="btn btn-danger btn-user btn-block">
                      Annuler
                    </a>
                  </form>
                  <form class="user" v-else>
                    <div class="form-group">
                      <input
                          v-model="$v.form.username.$model"
                          id="username"
                          name="username"
                          :class="{'is-invalid': $v.form.username.$error}"
                          type="text"
                          class="form-control form-control-user"
                          placeholder="Username">
                    </div>
                    <div class="form-group">
                      <input
                          v-model="$v.form.password.$model"
                          :class="{'is-invalid': $v.form.password.$error}"
                          name="password"
                          type="password"
                          class="form-control form-control-user"
                          placeholder="Password">
                    </div>
                    <b-form-invalid-feedback :state="!apiRslt.fetch.error" class="text-center my-3">
                      Les identifiants de connexion sont incorrectes. <br>
                    </b-form-invalid-feedback>
                    <a id="submit-signin" @click="submitForm" class="btn btn-primary btn-user btn-block">
                      Login
                    </a>
                    <div class="text-center my-3">
                      <a href="#" @click="isResetAsked = true"><small>Mot de passe oublié ?</small></a>
                    </div>
                  </form>
                  
                  <hr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import LoaderOverlay from "@/core/components/LoaderOverlay.vue";
import { required } from "vuelidate/lib/validators"

export default {
  name: 'SignIn',
  components:{
    LoaderOverlay
  },
  computed:{
    ...mapState('auth',['apiRslt']),
    ...mapGetters('auth',['isAuthenticated'])
  },
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      resetForm:{
        email:''
      },
      isResetAsked: false,
      showError: false
    }
  },
  methods:{
    ...mapActions('auth',['login','isAlwaysLogIn','resetPassword','resetApiFetch']),
    async submitForm(){
      this.$v.form.$reset()
      this.$v.form.$touch()
      if(!this.$v.form.$error){
        await this.login(this.form);
        this.$router.push({ name: 'home'});
      }
    },
    submitResetAsk(){
      this.$v.resetForm.$reset()
      this.$v.resetForm.$touch()
      if(!this.$v.resetForm.$error){
        this.resetPassword(this.resetForm)
      }
    }
  },
  created() {
    this.isAlwaysLogIn()
  },
  validations: {
    form:{
      username: { required },
      password: { required }
    },
    resetForm:{
      email: { required }
    }
  },
}
</script>

<style scoped>

</style>
